import { useState, useEffect } from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { Tag } from 'primereact/tag';
import { IconField } from 'primereact/iconfield';
import { InputIcon } from 'primereact/inputicon';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { getVacacionesOperadores } from './Integracion';
import './VacacionesOperadores.scss';

const AUTH_CONFIG = {
    Autorizado:      { severity: 'success' },
    Rechazado:       { severity: 'danger' },
    'No autorizado': { severity: 'warning' },
};

const autorizacionTemplate = ({ autorizacion }) => (
    <Tag value={autorizacion} severity={AUTH_CONFIG[autorizacion]?.severity ?? 'info'} />
);

export default function VacacionesOperadores() {
    const [data, setData] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [desde, setDesde] = useState(null);
    const [hasta, setHasta] = useState(null);
    const [loading, setLoading] = useState(false);

    const fetchData = async (d, h) => {
        setLoading(true);
        try {
            const json = await getVacacionesOperadores(d, h);
            setData(json);
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => { fetchData(null, null); }, []);

    const handleLimpiar = () => {
        setDesde(null);
        setHasta(null);
        fetchData(null, null);
    };

    const header = (
        <div className="vacaciones-header">
            <span className="vacaciones-title">Vacaciones</span>
            <div className="vacaciones-filters">
                <Calendar
                    value={desde}
                    onChange={e => setDesde(e.value)}
                    placeholder="Desde"
                    dateFormat="dd/mm/yy"
                    showIcon
                    maxDate={hasta ?? undefined}
                />
                <Calendar
                    value={hasta}
                    onChange={e => setHasta(e.value)}
                    placeholder="Hasta"
                    dateFormat="dd/mm/yy"
                    showIcon
                    minDate={desde ?? undefined}
                />
                <Button
                    label="Buscar"
                    icon="pi pi-search"
                    onClick={() => fetchData(desde, hasta)}
                    disabled={!desde && !hasta}
                />
                {(desde || hasta) && (
                    <Button
                        icon="pi pi-times"
                        text
                        severity="secondary"
                        tooltip="Limpiar"
                        onClick={handleLimpiar}
                    />
                )}
                <IconField iconPosition="left">
                    <InputIcon className="pi pi-search" />
                    <InputText
                        placeholder="Buscar..."
                        value={globalFilter}
                        onChange={e => setGlobalFilter(e.target.value)}
                    />
                </IconField>
            </div>
        </div>
    );

    return (
        <div className="vacaciones-container">
            <DataTable
                value={data}
                loading={loading}
                header={header}
                globalFilter={globalFilter}
                paginator
                rows={25}
                rowsPerPageOptions={[25, 50, 100]}
                emptyMessage="Sin registros"
                stripedRows
                scrollable
                scrollHeight="calc(100vh - 235px)"
            >
                <Column field="chofer"         header="Chofer"             sortable />
                <Column field="fechaRegistro"  header="Fecha de registro"  sortable />
                <Column field="inicioVacacion" header="Inicio de vacación" sortable />
                <Column field="finVacacion"    header="Fin de vacación"    sortable />
                <Column field="dias"           header="Días"               sortable style={{ width: '5rem' }} />
                <Column field="autorizacion"   header="Autorización"       body={autorizacionTemplate} sortable />
            </DataTable>
        </div>
    );
}
